import { render } from "./Compositionitem.vue?vue&type=template&id=71a317c6"
import script from "./Compositionitem.vue?vue&type=script&lang=js"
export * from "./Compositionitem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__